import React, { useEffect, useRef, useState } from "react";
import { Grid } from "@mui/material";
import { FormikTextInput, FormikSelectInput } from "components/UI/Inputs/FormikInputs";
import classes from "./index.module.scss";
import { FormButton } from "components";
import { Formik, Form } from "formik";
import * as yup from "yup";
import { FORM_ERROR_MESSAGES } from "consts/errorMessages";
import { useMIAService } from "hooks/useMIAService";
import { SBMTipoDeDocumentoGet } from "services/services-mia";

const signTypes = [{ value: "D", name: "Digital" }, { value: "O", name: "Ológrafa" }, { value: "H", name: "Híbrida" }]

export default function FormActions({ handleSubmit, initialValues }) {
    //Local States
    const [documentType, setDocuemntType] = useState([]);
    const formikRef = useRef();
    const getSBMTipoDeDocumento = useMIAService(SBMTipoDeDocumentoGet, false);

    //Hooks 
    useEffect(() => {
        // console.log("Esto es la referencia de formik", formikRef)
        getDocumentType();
    }, [])

    //Functions 
    const getDocumentType = async () => {
        try {
            const response = await getSBMTipoDeDocumento();
            
            const responseToDocumentType = response.result.map((document) => {
                const { sbmTipoDeDocumentoId, sbmTipoDeDocumentoNombre, sbmTipoDeDocumentoAgrupa } = document;
                return {
                    tipoDeDocumentoId: sbmTipoDeDocumentoId,
                    tipoDeDocumentoNombre: sbmTipoDeDocumentoNombre,
                    tipoDeDocumentoAgrupa: sbmTipoDeDocumentoAgrupa
                }
            })
            formikRef.current.setFieldValue("tipoDocumento", responseToDocumentType[0].tipoDeDocumentoId);
            setDocuemntType(responseToDocumentType);
        } catch (e) {
            //Manejar error;
            console.error("Error fetching document types:", e);
        }
    }
    const ayer = () => {
        let hoy = new Date();
        let DIA_EN_MILISEGUNDOS = 24 * 60 * 60 * 1000;
        let ayer = new Date(hoy.getTime() - DIA_EN_MILISEGUNDOS);
        return ayer;
    }

    return (
        <Formik
            initialValues={initialValues}
            onSubmit={(values) => {
                handleSubmit(values);
            }}
            validationSchema={
                yup.object({
                    nombreDocumento: yup.string(FORM_ERROR_MESSAGES.text)
                        .required(FORM_ERROR_MESSAGES.required),
                    descripcion: yup.string(FORM_ERROR_MESSAGES.text)
                        .required(FORM_ERROR_MESSAGES.required),
                    fechaDocumento: yup.date(FORM_ERROR_MESSAGES.date)
                        .required(FORM_ERROR_MESSAGES.required)
                        .min(ayer(), "Fecha debe ser mayor o igual a hoy"),
                    // grupo: yup.number()
                    //     .nullable()
                    //     // .transform((value, originalValue) =>
                    //     //     originalValue === '' ? null : value
                    //     // )
                    //     .when("grupo", {
                    //         is: "GE",
                    //         then: yup.number("Debe enviar un numero").required("Debe enviar un numero")
                    //     })
                    //     .typeError('Debe enviar un número'),
                    cantFirmantesExternos: yup
                        .number()
                        .nullable()
                        .when("requiereFirma", {
                            is: true,
                            then: yup
                                .number()
                                .moreThan(0, "Debe haber al menos un firmante externo")
                                .required("Campo obligatorio"),
                            otherwise: yup.number().nullable(),
                        })
                })
            }
            innerRef={formikRef}

        >

            {({
                values
            }) => {
                const document = documentType.find(document => document.tipoDeDocumentoId === Number(values.tipoDocumento));

                return <Form noValidate>
                    <Grid container height={"60vh"} display={"flex"} justifyContent={"center"} alignItems={"center"} className={classes.container}>
                        <Grid item md={12} lg={12}>
                            <Grid container spacing={2}>

                                <Grid item lg={4}>

                                    <FormikSelectInput labelText={"Tipo de documento"} name={"tipoDocumento"} >
                                        {
                                            documentType.map((document) => (
                                                <option value={document.tipoDeDocumentoId} key={document.tipoDeDocumentoId}>{document.tipoDeDocumentoNombre} </option>
                                            ))
                                        }
                                    </FormikSelectInput>
                                </Grid>
                                <Grid item lg={5}>
                                    <FormikTextInput labelText={"Nombre del documento"} name={"nombreDocumento"} />
                                </Grid>
                                <Grid item lg={3}>
                                    <FormikTextInput labelText={"Fecha de documento"} type={"date"} name={"fechaDocumento"} />
                                </Grid>
                            </Grid>
                        </Grid>
                        {/* Row 3 */}
                        <Grid item md={12} lg={12}>
                            <FormikTextInput labelText={"Descripcion"} type="text" fullWidth placeholder="Ejemplo de texto: Contrato comercial bilateral" name={"descripcion"} />
                        </Grid>
                        <Grid item display={"flex"} gap={"2em"} md={12} lg={12}>
                            <Grid lg={6}>
                                <FormikTextInput labelText={"Referencia"} type="text" fullWidth placeholder="Documento seguido por..." name={"referencia"} />
                            </Grid>
                            <Grid lg={6}>
                                <FormikSelectInput labelText={"Tipo de firma"} fullWidth name={"tipoFirma"} >
                                    {
                                        signTypes.map((tipo) => (
                                            <option value={tipo.value} key={tipo.value}>{tipo.name} </option>
                                        ))
                                    }
                                </FormikSelectInput>
                            </Grid>
                        </Grid>
                        <Grid item md={12} lg={12} display={"flex"} gap={"2em"}>
                            <Grid item lg={6}>
                                <FormikTextInput labelText={"ID externa"} type="text" fullWidth placeholder="ID externa" name={"idExterna"} />
                            </Grid>
                            <Grid item lg={6}>
                                <FormikTextInput 
                                    style={{ display: "flex", flex: "1" }} 
                                    labelText={"Grupo"} 
                                    type="text" 
                                    fullWidth 
                                    placeholder="Grupo" 
                                    name={"grupo"} 
                                    disabled={document?.tipoDeDocumentoAgrupa !== "Y"}
                                />
                            </Grid>
                        </Grid>
                        <Grid item display={"flex"} gap={"2em"} md={12} lg={12}>
                            <Grid item lg={6} >
                                <FormikTextInput fullWidth labelText={"Cant. firmantes internos"} name={"cantFirmantesInternos"} type={"number"} />
                            </Grid>
                            <Grid item lg={6}>
                                <FormikTextInput fullWidth labelText={"Cant. firmantes externos"} name={"cantFirmantesExternos"} type={"number"} />
                            </Grid>
                        </Grid>
                        <FormButton
                            newFormData={{ button: "Guardar" }}
                            hasConfirmationModal={true} />
                    </Grid>
                </Form>
            }

            }
        </Formik >
    );
}